import './App.css';
import Visualizer from './Visualizer';
function App() {
  return (
    <div className="bg-gradient-to-t from-black to-gray-700 w-screen h-screen">
      <Visualizer />
    </div>
  );
}

export default App;
